import React from 'react'

const FacebookIcon = () => {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.5 0h-17C1.67 0 0 1.67 0 3.5v17c0 1.83 1.67 3.5 3.5 3.5h8.28v-8.74h-2.37v-3.41h2.37v-2.61c0-2.35 1.43-3.63 3.52-3.63 1 0 1.86.08 2.11.12v2.44l-1.44.01c-1.14 0-1.36.54-1.36 1.33v1.74h2.72l-.36 3.41h-2.36v8.74h4.62c1.83 0 3.5-1.67 3.5-3.5v-17c0-1.83-1.67-3.5-3.5-3.5z"
        fill="#1877f2"
      />
    </svg>
  )
}

export default FacebookIcon
